import Transaction from "components/ui/Transaction";
import UILabel from "components/ui/UILabel";
import dayjs from "dayjs";
import React from "react";
import { getUsersProfile } from "store/api/apiSlice";
import styled from "styled-components";
import {
  ApiCardTransaction,
  getTransactionsByDate,
} from "utils/api/cardTransactions";
import { ApiUsersProduct } from "utils/api/users";
import { formatDateString } from "utils/date";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0;
  margin: 0;

  list-style: none;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
  margin: 0;

  list-style: none;
`;

const getSectionLabel = (date: string) => {
  const diff = dayjs(date).diff(dayjs(), "day");

  if (diff === 0) return "Today";
  if (diff === -1) return "Yesterday";

  return formatDateString(date, "textShort");
};

interface Props {
  transactions?: ApiCardTransaction[];
}

const TransactionsByDate: React.FC<Props> = ({ transactions }) => {
  const { data: userProfile } = getUsersProfile();
  const transactionsByDate = getTransactionsByDate(transactions);

  return (
    <Wrapper>
      {transactionsByDate.map((section) => (
        <Section key={section.date}>
          <UILabel.Small caps bold>
            {getSectionLabel(section.date)}
          </UILabel.Small>
          <List>
            {section.transactions?.map((transaction) => (
              <li key={transaction.id}>
                <Transaction
                  {...transaction}
                  showBadge={userProfile?.product === ApiUsersProduct.ewaFlex}
                />
              </li>
            ))}
          </List>
        </Section>
      ))}
    </Wrapper>
  );
};

export default TransactionsByDate;
